import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { IAuthorizationState } from './authorization-state.store';
import {
  AUTHORIZATION_AUTHORIZE,
  AUTHORIZATION_STATUS,
  AUTHORIZATION_AUTHORIZE_SUCCESS,
  AUTHORIZATION_SIGNOUT,
  AUTHORIZATION_FUNCTIONALITIES,
  AUTHORIZATION_FORGOT_PASSWORD,
  AUTHORIZATION_CHANGE_PASSWORD,
  AUTHORIZATION_CHECK_SESSION,
  AUTHORIZATION_SIGN_IN,
  AUTHORIZATION_SIGN_IN_FAILED,
  AUTHORIZATION_SIGN_IN_LOADING,
  AUTHORIZATION_VERIFY_EMAIL,
} from './authorization-types.store';
import { IUserLogin } from '../../models/user';
import { ActivityStatus } from '../../common/enums';
import { IAuthorizationService } from '../../services';
import { CookieHelper } from '../../utils/CookieHelper.util';
import Axios from 'axios';
import VueRouter from 'vue-router';

export const actions: ActionTree<IAuthorizationState, IRootState> = {

  [AUTHORIZATION_AUTHORIZE]:
    async ({ getters, commit }, payload: { self: any, userLogin?: IUserLogin }): Promise<string> => {
      try {
        if (payload.userLogin) {
          commit(AUTHORIZATION_STATUS, ActivityStatus.Loading);
          return await (getters.service as IAuthorizationService)
            .handleAuthorize(payload.userLogin)
            .then(({ accessToken }) => {
              commit(AUTHORIZATION_STATUS, ActivityStatus.Loaded);
              commit(AUTHORIZATION_AUTHORIZE_SUCCESS, true);

              localStorage.setItem('token', accessToken);
              CookieHelper.set(payload.self, 'userSession', accessToken);
              Axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

              return Promise.resolve(accessToken);
            })
            .catch(error => {
              commit(AUTHORIZATION_AUTHORIZE_SUCCESS, false);
              commit(AUTHORIZATION_STATUS, ActivityStatus.LoadFailed);
              return Promise.reject(error);
            })
        } else
          return await CookieHelper.get(payload.self, 'userSession')
            .then((token: string) => {
              commit(AUTHORIZATION_AUTHORIZE_SUCCESS, true);
              localStorage.setItem('token', token);
              Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
              return Promise.resolve(token);
            })
            .catch(error => {
              return Promise.reject(error)
            })
      } catch (error) {
        commit(AUTHORIZATION_AUTHORIZE_SUCCESS, false);
        return Promise.reject(error);
      }
    }
  , [AUTHORIZATION_SIGNOUT]:
    async ({ commit, state }, self: any) => {
      return state.service!.handleLogout()
        .then(response => {
          return response;
        })
        .catch(error => error)
    }
  , [AUTHORIZATION_FUNCTIONALITIES]: async ({ getters, state }, moduleName: string) => {
    /** Get funcnalities from the storage. Unless fetch from api */
    const functionalities = localStorage.getItem(moduleName);
    let fns= JSON.parse(functionalities);

    if(localStorage.getItem('token') && ((fns && fns['name'] && fns['name'] === 'NotAuthenticated') || functionalities === null)){
     return state.service.handleGetFunctionalities(moduleName)
     .then(response => {
       localStorage.setItem(moduleName, JSON.stringify(response));
       return response;
     })
     .catch(error => console.log(error));
    }

    if (functionalities !== null && (!fns['code'])) return Promise.resolve(JSON.parse(functionalities));
  },
  [AUTHORIZATION_FORGOT_PASSWORD]: async ({ getters, state }, payload) => {
    return await state.service.sendForgotPassword(payload)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  [AUTHORIZATION_CHANGE_PASSWORD]: async ({ getters, state }, payload) => {
    return await state.service.submitChangePassword(payload)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },
  [AUTHORIZATION_SIGN_IN]: async ({ state, commit, dispatch }, payload: { userInfo: IUserLogin, router: VueRouter }) => {
    if (state.signInPayload.activityStatus === ActivityStatus.Loading) {
      return;
    }
    commit(AUTHORIZATION_SIGN_IN_LOADING)
    await state.service!.handleAuthorize(payload.userInfo)
      .then(res => {
        commit(AUTHORIZATION_SIGN_IN, res)
        dispatch('user/USER_INFO', payload.router, { root: true })
      })
      .catch(error => {
        commit(AUTHORIZATION_SIGN_IN_FAILED, error)
      })
  },
  [AUTHORIZATION_CHECK_SESSION]: async ({ state, dispatch }, router: VueRouter) => {
    const hasSession: boolean = await state.service!.handleCheckSession(state.signInPayload.accessToken)
    if (hasSession) {
      dispatch('user/USER_INFO', router, { root: true })
    } else {
      localStorage.clear()
      if (router.currentRoute.path !== '/verifyChanges' && router.currentRoute.path !== '/') {
        router.push({ path: '/', query: { redirectTo: encodeURI(location.href) } })
      }
    }

  },
  [AUTHORIZATION_VERIFY_EMAIL]: async ({ state }, payload: { router: VueRouter, token: string }) => {
    return await state.service.verifyEmail(payload.token)
      .then(res => {
        return Promise.resolve(res)
      })
      .catch(err => {
        return Promise.reject(err)
      })
  }
}


// WEBPACK FOOTER //
// ./src/store/authorization/authorization-actions.store.ts